<template>
  <transition-group
    name="wizard-items"
    tag="div"
    class="wizard-box"
    :class="classObject"
  >
    <div
      v-for="item in items"
      :key="item.route"
      class="item"
      :class="{ active: isActive(item), over: isOver(item) }"
    >
      <div class="flex items-center">
        <h3
          class="overflow-hidden whitespace-nowrap text-ellipsis leading-tight"
        >
          {{ item.title }}
        </h3>
        <span v-if="isOver(item)" class="completed">
          <fluent-icon icon="checkmark" />
        </span>
      </div>
      <span class="step">
        {{ items.indexOf(item) + 1 }}
      </span>
      <p>{{ item.body }}</p>
    </div>
  </transition-group>
</template>

<script>
/* eslint no-console: 0 */
import globalConfigMixin from 'shared/mixins/globalConfigMixin';

export default {
  mixins: [globalConfigMixin],
  props: {
    isFullwidth: Boolean,
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    classObject() {
      return 'w-full';
    },
    activeIndex() {
      return this.items.findIndex(i => i.route === this.$route.name);
    },
  },
  methods: {
    isActive(item) {
      return this.items.indexOf(item) === this.activeIndex;
    },
    isOver(item) {
      return this.items.indexOf(item) < this.activeIndex;
    },
  },
};
</script>

<style lang="scss" scoped>
// The wizard's geometry lives in `assets/scss/views/settings/inbox.scss`, which is
// outside this component. What is corrected here is only what the brand layer
// cannot express from there: the accent has to be the theme-aware foreground to
// stay legible on the ink ground, and no glyph is pure white.
.wizard-box {
  .item {
    &.active h3 {
      @apply text-accent-mint;
    }

    .step {
      @apply text-slate-25 dark:text-slate-25;
    }

    // The connector between completed steps is a rail — mint's actual job.
    &.over::after,
    &.over + .item::before {
      @apply bg-accent-mint;
    }
  }
}
</style>
